import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  collapsed: {},
  guidingModalOpen: 'INIT',
};

const settingsReducer = createReducer(initialState)({
  [types.SET_IS_COLLAPSED]: (state, { payload }) => {
    return {
      ...state,
      collapsed: {
        ...state.collapsed,
        [payload.id]: payload.collapsed,
      },
    };
  },
  [types.UI_SHOW_GUIDING_MODAL]: (state, { payload }) => {
    return {
      ...state,
      guidingModalOpen: payload.open,
    };
  },
});

export default settingsReducer;
